import { dollarsToCents } from "../models/DealerLedger.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * One investor card. The API lists investors only, so balances stay zero
 * until a ledger endpoint lands.
 */
export class InvestorCard {
    id;
    name;
    deposits;
    withdrawals;
    saleReturns;
    balance;
    tiedUp;
    liquid;
    totalCapital;
    constructor(id, name, deposits = 0, withdrawals = 0, saleReturns = 0, balance = 0, tiedUp = 0, liquid = 0, totalCapital = 0) {
        this.id = id;
        this.name = name;
        this.deposits = deposits;
        this.withdrawals = withdrawals;
        this.saleReturns = saleReturns;
        this.balance = balance;
        this.tiedUp = tiedUp;
        this.liquid = liquid;
        this.totalCapital = totalCapital;
    }
    static fromRow(row) {
        return new InvestorCard(row.id, row.name);
    }
}
/** Investor cards and manual transactions. */
export class InvestorLedgerViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ investors: [], history: [], loading: false, error: null });
        this.client = client;
    }
    async load() {
        await this.run(async () => {
            const rows = await this.client.listInvestors();
            this.setState({ investors: rows.map(InvestorCard.fromRow) });
        }, "Failed to load investors.");
    }
    /** Per-investor history is not on the API yet: always empty. */
    selectHistory(_investorId) {
        this.setState({ history: [] });
    }
    async create(name) {
        const ok = await this.run(async () => {
            await this.client.createInvestor(name.trim(), "");
            await this.load();
            return true;
        }, "Failed to create investor.");
        return ok === true;
    }
    async addTransaction(investorId, draft) {
        const ok = await this.run(async () => {
            await this.client.addInvestorTransaction(investorId, {
                type: draft.type || "DEPOSIT",
                amountCents: dollarsToCents(draft.amount),
                date: draft.date || new Date().toISOString().slice(0, 10),
                note: draft.notes,
            });
            await this.load();
            return true;
        }, "Failed to record transaction.");
        return ok === true;
    }
}
//# sourceMappingURL=InvestorLedgerViewModel.js.map